import { Tab } from '@headlessui/react';
import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

import { InterHeaderStyles } from '../../styles';

type Props = {
  tabs: {
    label: string;
    errorCount?: number;
    hideTab?: boolean;
  }[];
  localePrefix?: string;
  selectedIndex: number;
  setSelectedIndex: (selected: number) => void;
  isSticky?: boolean;
};

export const TabGroup = ({
  tabs,
  localePrefix,
  selectedIndex,
  setSelectedIndex,
  isSticky = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex gap-3 ${
        isSticky ? 'sticky -top-5 bg-white z-[2] py-4' : ''
      }`}
    >
      <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
        <Tab.List className="flex gap-3">
          {tabs.map((tab, index) =>
            tab.hideTab ? null : (
              <Tab
                key={`${tab}-${index}`}
                className={({ selected }) =>
                  `py-2 px-3 rounded-lg outline-none text-sm ${
                    selected ? 'bg-active text-blue-500' : 'bg-transparent'
                  }` + InterHeaderStyles
                }
              >
                <div className="flex items-center gap-2">
                  {t(localePrefix ? `${localePrefix}.${tab.label}` : tab.label)}
                  {tab.errorCount && tab.errorCount > 0 ? (
                    <span className="flex h-3.5 w-3.5 px-1 justify-center items-center rounded-full text-white bg-[#EA1A1A] text-[9px] font-inter font-bold leading-[9px]">
                      {tab.errorCount}
                    </span>
                  ) : null}
                </div>
              </Tab>
            ),
          )}
        </Tab.List>
      </Tab.Group>
    </div>
  );
};
